import {useTranslation} from "react-i18next";
import React from "react";

const FinishHistoryRoom = function ({points, winnerId, userId, loserId, winAmount, currency}) {
    const {t} = useTranslation();

    return (
        <div className="modal__history-finish">
            <h2>{winnerId === userId ? t("modals.finish.you_won") : t("modals.finish.opponent_won")}</h2>
            <div className="modal__finish--content">
                <p className="modal__finish--result">
                    {t("modals.finish.game_score")}
                    {points &&
                        <span>{`${points[winnerId]} : ${points[loserId]}`}</span>}
                </p>

                {
                    <p className={"modal__finish--prize"}>
                        {t("modals.finish.amount")}
                        <span className="modal__finish--prize--amount">
                                {winAmount}
                            <span className='currency-small'> {currency}</span>
                            </span>

                    </p>
                }
            </div>
        </div>
    )
}
export default FinishHistoryRoom